import React from "react";
import { motion } from "framer-motion";

export default function AboutUs({ className }) {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 40, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 80,
        damping: 15,
      },
    },
  };

  const coffeeBeanSvg = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='260' height='260' viewBox='0 0 260 260'%3E%3Cg fill='none' stroke='%238C4F2B' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='0.06'%3E%3Cpath d='M180,45 L205,45 L210,75 L175,75 Z' /%3E%3Cpath d='M175,50 H165 C160,50 160,70 165,70 H175' /%3E%3Cpath d='M192,45 V41 C192,39 198,39 198,41 V45' /%3E%3Cpath d='M210,68 Q222,68 220,53 Q218,42 208,46' /%3E%3Cpath d='M40,75 C60,75 80,75 80,85 C80,90 40,90 40,85 Z' /%3E%3Cpath d='M45,60 Q60,78 75,60 Z' /%3E%3Cpath d='M45,60 H75' /%3E%3Cpath d='M75,63 C80,63 81,71 75,71' /%3E%3Cpath d='M55,52 Q58,47 55,42 M65,52 Q68,47 65,42' /%3E%3Cpath d='M20,25 C15,18 28,12 32,18 C36,24 25,32 20,25 Z' /%3E%3Cpath d='M17,21 Q25,20 33,18' /%3E%3Cpath d='M110,35 C115,28 128,32 125,39 C122,46 110,42 110,35 Z' /%3E%3Cpath d='M110,38 Q118,36 125,35' /%3E%3Cpath d='M140,210 C145,203 158,207 155,214 C152,221 140,217 140,210 Z' /%3E%3Cpath d='M140,213 Q148,211 155,210' /%3E%3Cpath d='M220,110 C215,103 228,97 232,103 C236,109 225,117 220,110 Z' /%3E%3Cpath d='M217,106 Q225,105 233,103' /%3E%3Cpath d='M35,130 L75,130 L59,155 H51 Z' /%3E%3Cpath d='M50,155 H60 L62,159 V167 L60,171 H50 L48,167 V159 Z' /%3E%3Cpath d='M55,155 V171' /%3E%3Cpath d='M51,171 L38,198 C36,204 42,210 50,210 H60 C68,210 74,204 72,198 L59,171 Z' /%3E%3Cpath d='M42,190 H68' /%3E%3Cpath d='M180,145 V195 C180,200 205,200 205,195 V145 Z' /%3E%3Cpath d='M180,150 H170 V185 H180' /%3E%3Cpath d='M177,145 H208 V142 H177 Z' /%3E%3Cpath d='M192.5,142 V128' /%3E%3Cpath d='M192.5,124 A 4 4 0 1 1 192.5,125' /%3E%3Cpath d='M180,170 H205' /%3E%3Cpath d='M120,110 L140,110 L135,150 L125,150 Z' /%3E%3Cpath d='M118,110 H142 V106 H118 Z' /%3E%3Cpath d='M130,106 L136,88' /%3E%3Cpath d='M122,122 h6 v6 h-6 Z M130,134 h6 v6 h-6 Z' /%3E%3Cpath d='M110,180 L113,170 L110,160 L115,167 L125,163 L118,172 L124,180 L115,176 Z' /%3E%3Cpath d='M230,170 L234,163 L230,156 L235,161 L243,158 L238,165 L242,172 L235,168 Z' /%3E%3Ccircle cx='95' cy='115' r='1.5' fill='%238C4F2B' fill-opacity='0.06' stroke='none' /%3E%3Ccircle cx='105' cy='120' r='1' fill='%238C4F2B' fill-opacity='0.06' stroke='none' /%3E%3Ccircle cx='160' cy='95' r='1.5' fill='%238C4F2B' fill-opacity='0.06' stroke='none' /%3E%3Ccircle cx='80' cy='30' r='1' fill='%238C4F2B' fill-opacity='0.06' stroke='none' /%3E%3Ccircle cx='160' cy='155' r='1' fill='%238C4F2B' fill-opacity='0.06' stroke='none' /%3E%3Ccircle cx='200' cy='105' r='1.5' fill='%238C4F2B' fill-opacity='0.06' stroke='none' /%3E%3C/g%3E%3C/svg%3E";

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Archivo:wght@700;800;900&display=swap" rel="stylesheet" />

      <section
        className={"relative w-full py-24 sm:py-32 px-6 sm:px-12 md:px-16 flex flex-col items-center justify-center overflow-hidden " + (className || "")}
        style={{
          backgroundColor: "#FAF4EA",
          backgroundImage: "url(\"" + coffeeBeanSvg + "\")",
          backgroundRepeat: "repeat",
          fontFamily: "'Archivo', sans-serif",
        }}
      >
        {/* Aesthetic ambient lighting */}
        <div className="absolute top-10 left-10 w-96 h-96 bg-[#F4A61D]/5 rounded-full blur-[100px] pointer-events-none" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#2D1505]/5 rounded-full blur-[100px] pointer-events-none" />

        {/* Decorative subtle background pattern */}
        <div className="absolute inset-0 bg-[radial-gradient(#2D1505_1px,transparent_1px)] [background-size:32px_32px] opacity-[0.015] pointer-events-none" />

        {/* Outer Wrapper with stagger animation */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="w-full max-w-[1300px] mx-auto flex flex-col items-center justify-center gap-y-2 sm:gap-y-4"
        >
          {/* ROW 1: USE | [pill] | PREMIUM BEANS */}
          <motion.div
            variants={itemVariants}
            className="flex flex-row flex-nowrap items-center justify-center gap-x-[30px] text-center w-full overflow-visible"
          >
            <span
              className="font-extrabold text-[#2B170A] select-none uppercase tracking-tight whitespace-nowrap"
              style={{ fontSize: "clamp(34px, 10vw, 132px)", lineHeight: "1" }}
            >
              USE
            </span>

            {/* Pill 1: looping round video */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300, damping: 15 }}
              className="h-[52px] sm:h-[85px] md:h-[102px] w-[115px] sm:w-[210px] md:w-[275px] bg-[#D6D4D0] rounded-full flex items-center justify-center cursor-pointer shadow-sm hover:shadow-md transition-all relative overflow-hidden group shrink-0"
            >
              <video
                src="https://cdn.jiro.build/Creame%20ecom/Videos/round%20video.mp4"
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover absolute inset-0 pointer-events-none"
              />
            </motion.div>

            <span
              className="font-extrabold text-[#2B170A] select-none uppercase tracking-tight whitespace-nowrap"
              style={{ fontSize: "clamp(34px, 10vw, 132px)", lineHeight: "1" }}
            >
              PREMIUM BEANS
            </span>
          </motion.div>

          {/* ROW 2: FRESHLY GROUND | [pill] */}
          <motion.div
            variants={itemVariants}
            className="flex flex-row flex-nowrap items-center justify-center gap-x-[30px] text-center w-full overflow-visible"
          >
            <span
              className="font-extrabold text-[#2B170A] select-none uppercase tracking-tight whitespace-nowrap"
              style={{ fontSize: "clamp(34px, 10vw, 132px)", lineHeight: "1" }}
            >
              FRESHLY GROUND
            </span>

            {/* Pill 2: Airplane Takeoff video */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300, damping: 15 }}
              className="h-[52px] sm:h-[85px] md:h-[102px] w-[115px] sm:w-[210px] md:w-[275px] bg-[#D6D4D0] rounded-full flex items-center justify-center cursor-pointer shadow-sm hover:shadow-md transition-all relative overflow-hidden group shrink-0"
            >
              <video
                src="https://cdn.jiro.build/Creame%20ecom/Videos/Airplane%20Takeof%20Video%20(online-video-cutter.com).mp4"
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover absolute inset-0 pointer-events-none"
              />
            </motion.div>
          </motion.div>

          {/* ROW 3: TO UNDENIABLY COFFEE */}
          <motion.div
            variants={itemVariants}
            className="flex flex-row flex-nowrap items-center justify-center text-center w-full overflow-visible"
          >
            <span
              className="font-extrabold text-[#2B170A] select-none uppercase tracking-tight whitespace-nowrap"
              style={{ fontSize: "clamp(30px, 9.5vw, 126px)", lineHeight: "1" }}
            >
              TO UNDENIABLY COFFEE
            </span>
          </motion.div>
        </motion.div>
      </section>
    </>
  );
}